<template>
  <v-app>
    <v-app-bar
      v-if="showMenu()"
      :class="{ 'd-flex justify-center': !showMenu() }"
      class="header"
      color="#ffffff"
      app
    >
      <v-sheet
        class="d-flex align-center justify-space-between justify-sm-start px-3 mx-auto"
        color="transparent"
        max-width="1600px"
        width="100%"
      >
        <v-app-bar-nav-icon
          v-if="xsOnly"
          @click.stop="drawer = !drawer"
          small
        />

        <v-toolbar-title>
          <router-link to="/portfolio">
            <img class="d-block" :src="logo" :height="logoHeight" />
          </router-link>
        </v-toolbar-title>

        <div v-if="!xsOnly" class="d-flex align-center ml-1 mr-2 ml-md-10">
          <template v-for="(item, index) in items">
            <v-btn
              v-if="item?.is_master ? (getUser.is_master ? true : false) : true"
              :key="index + '-menu'"
              v-bind="item.bind"
              class="rounded-lg px-3 px-md-4 mx-md-1 menu-item"
              :class="{ 'menu-item-active': isRoutePath(item.route) }"
              depressed
              text
            >
              <!-- <v-icon class="mr-1" size="18">{{ item.icon }}</v-icon> -->
              <div class="text-body-1 text-none font-weight-medium">
                {{ item.title }}
              </div>
            </v-btn>
          </template>
        </div>

        <v-spacer v-if="!xsOnly" />

        <v-menu
          v-if="getUser?.name"
          content-class="rounded-lg mt-2 menu-dropdown"
          min-width="160px"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="xsOnly"
              v-bind="attrs"
              v-on="on"
              color="primary"
              depressed
              x-small
              fab
            >
              <div
                class="white--text text-subtitle-1 text-uppercase font-weight-medium"
              >
                {{ getUser.name[0] }}
              </div>
            </v-btn>

            <v-btn
              v-else
              v-bind="attrs"
              v-on="on"
              class="rounded-lg px-0 px-sm-2"
              min-width="auto"
              color="#cccccc"
              large
              text
            >
              <v-sheet
                class="d-flex align-center justify-center rounded-circle"
                color="primary"
                height="32px"
                width="32px"
              >
                <div
                  class="white--text text-subtitle-1 text-uppercase font-weight-medium"
                >
                  {{ getUser.name[0] }}
                </div>
              </v-sheet>

              <div
                class="black--text text-body-1 text-none font-weight-medium ml-2"
              >
                {{ getUser.name.trim().split(" ")[0] }}
              </div>

              <v-icon color="#000000" right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list class="pa-1">
            <!-- <v-list-item
              v-if="getUser?.is_master"
              class="rounded-lg overflow-hidden px-3"
              to="/configuracoes"
              dense
            >
              <v-list-item-title> Configurações </v-list-item-title>
            </v-list-item> -->

            <v-list-item
              v-if="getUser?.is_master"
              class="rounded-lg overflow-hidden px-3"
              to="/usuarios"
              dense
            >
              <v-list-item-title> Usuários </v-list-item-title>
            </v-list-item>

            <!-- <v-list-item
              v-if="getUser?.is_master"
              class="rounded-lg overflow-hidden px-3"
              to="/links"
              dense
            >
              <v-list-item-title> Links </v-list-item-title>
            </v-list-item> -->

            <div v-if="getUser?.is_master" class="mx-n1">
              <v-divider class="my-1" />
            </div>

            <v-list-item
              @click.prevent="logout"
              class="error--text rounded-lg overflow-hidden px-3"
              dense
            >
              <v-list-item-title> Sair </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-sheet>
    </v-app-bar>

    <v-navigation-drawer
      v-if="showMenu()"
      v-model="drawer"
      temporary
      absolute
      dark
    >
      <v-list dense nav>
        <template v-for="(item, key) in items">
          <v-list-item
            v-if="item.is_master ? (getUser.is_master ? true : false) : true"
            @click="goToRoute(item)"
            :key="key + '-usermenu'"
            link
          >
            <v-list-item-title>
              <v-icon left>{{ item.icon }}</v-icon>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item link @click="logout">
          <v-list-item-title>
            <v-icon left>mdi-logout</v-icon>

            Sair
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>

    <v-snackbar
      v-for="(snackbar, index) in snackbars"
      :key="snackbar.id"
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
      :style="{ top: `${index * 60}px` }"
      :color="snackbar.color"
      :multi-line="true"
      max-width="200px"
      right
      top
    >
      <div class="d-flex">
        <v-icon v-if="snackbar.icon" class="mb-1 mr-2" size="18">
          {{ snackbar.icon }}
        </v-icon>

        {{ snackbar.message }}
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn
          @click="snackbar.visible = false"
          v-bind="attrs"
          absolute
          right
          icon
        >
          <v-icon size="18px"> mdi-window-close </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { server } from "@/config.js";
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    hiddenInRoutes: [
      "Início",
      "Login",
      "Link de Compartilhamento",
      "Link Completo",
    ],
    drawer: false,
    snackbars: [],
    areaUnit: [
      {
        text: "Alqueire",
        value: "alqueire",
      },
      {
        text: "Hectare",
        value: "hectare",
      },
      {
        text: "Metros (m²)",
        value: "metros",
      },
    ],
  }),
  computed: {
    ...mapGetters("users", ["getUser"]),
    domain() {
      return server.includes("fazendas");
    },
    items() {
      const items = [
        {
          title: "Portfólio",
          icon: "mdi-map-marker-radius",
          bind: {
            to: "/portfolio",
          },
        },
        {
          title: "Cadastro",
          icon: "mdi-user-outline",
          bind: {
            to: "/cadastro",
          },
          is_master: true,
        },
        {
          title: "Pedidos",
          icon: "mdi-pencil",
          bind: {
            to: "/pedidos",
          },
          is_master: true,
        },
        {
          title: "Links gerados",
          icon: "mdi-pencil",
          bind: {
            to: "/links",
          },
          is_master: true,
        },
      ];

      if (!this.domain)
        items.push({
          title: "Apresentação",
          bind: {
            href: "/apresentacao.pdf",
            target: "_blank",
          },
        });

      return items;
    },
    logo() {
      return this.domain
        ? "/img/canto-a-canto-fazendas.png"
        : "/img/sao-jose.png";
    },
    logoHeight() {
      return this.domain ? 30 : 42;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    ...mapActions("users", ["onLogout"]),
    isRoutePath(v) {
      return this.$route.path.startsWith(v);
    },
    showMenu() {
      if (this.hiddenInRoutes.includes(this.$route.name)) return false;
      return true;
    },
    logout() {
      this.onLogout();
      this.$router.push({ path: "/login" });
    },
  },
  mounted() {
    this.$eventHub.on("snackBar", (config) => {
      const color = {
        success: "#16A34A",
        info: "#2563EB",
        alert: "#F59E0B",
        error: "#DC2626",
      };
      const id = Date.now();

      this.snackbars.push({
        id,
        visible: true,
        timeout: config.timeout || 3000,
        icon: config.icon,
        message: config.message,
        color: color[config.type] || "light-blue darken-4",
      });

      setTimeout(() => {
        this.snackbars = this.snackbars.filter((s) => s.id !== id);
      }, 3000);
    });
  },
};
</script>

<style lang="scss">
.container:not(.container--fluid):not(.link-page) {
  max-width: 1400px;
}

.container:not(.container--fluid).link-page {
  max-width: 1200px;
}

.menu {
  color: red !important;
}

.menu-dropdown {
  border: 1px solid #e1ddde !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -2px rgba(0, 0, 0, 0.1) !important;

  .v-list-item--link {
    min-height: 36px;
    transition: all 0.1s ease;

    &:hover {
      background-color: #107823;
      color: #ffffff !important;
    }
  }

  .v-list-item--active {
    &:before {
      opacity: 0;
    }
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.tab-left .v-tab {
  justify-content: left !important;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1ms;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.v-list-item__action {
  margin-bottom: 0 !important;
  margin-right: 6px !important;
  margin-top: 0 !important;
}

.v-subheader {
  font-weight: 700 !important;
}

.v-main__wrap {
  background-color: #f7f8fa !important;
}

.position-relative {
  position: relative;
}

.card-item {
  background-color: #ffffff !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;

  &:not(.v-data-table) {
    border: 1px solid #dbdee1 !important;
  }
}

.alert-inconsistency {
  position: absolute !important;
  left: -20px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.chip-control {
  border-radius: 8px !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  height: auto !important;
  padding: 2px 8px !important;
}

.form-control {
  fieldset {
    color: #dbdee1 !important;
    transition: all 0.1s linear !important;
  }

  &.small {
    .v-input__slot {
      min-height: 36px !important;
    }
  }

  &.v-input--is-focused {
    fieldset {
      color: var(--v-primary-base) !important;
    }
  }

  input {
    font-size: 14px !important;
    font-weight: 400 !important;

    &::placeholder {
      color: #616161 !important;
      opacity: 1 !important;
    }
  }
}

.v-snack__wrapper {
  border-radius: 12px !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
  min-height: 48px !important;
  padding-right: 0 !important;
}

.v-snack__content {
  font-weight: 500 !important;
  font-size: 14px !important;
  padding-left: 16px !important;
  padding-right: 48px !important;
}
</style>

<style lang="scss" scoped>
.header::v-deep {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;

  .v-toolbar__content {
    padding-left: 0;
    padding-right: 0;

    @media screen and (max-width: 599.9px) {
      justify-content: center;
    }
  }
}

.menu-item::v-deep {
  color: #333;
  transition: all 0.1s linear;

  &:hover {
    color: #000000;
  }

  &.menu-item-active {
    color: #107823;
  }
}
</style>
